import { Button, Stack } from 'components';
import aiScribeDrawerBackgroundIntro from 'assets/png/aiScribeDrawerBackgroundIntro.png';
import { useAiScribeContext } from 'modules/aiScribe/context/useAiScribe';

import style from './idleScreen.module.scss';

const IdleScreen = () => {
  const { startRecording, initializing, handleDrawerClose } = useAiScribeContext();

  return (
    <Stack height="100%" width="100%" display="flex" pb="52px">
      <img src={aiScribeDrawerBackgroundIntro} className={style.backgroundIntro} />
      <Stack
        position="relative"
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="flex-end"
      >
        <Stack
          display="flex"
          flexDirection="column"
          gap="40px"
          width="100%"
          height="100%"
          justifyContent="flex-end"
        >
          <p className={style.description}>Is your client OK with being recorded?</p>
          <Stack width="100%" display="flex" flexDirection="column" gap="16px">
            <Button
              text="Yes, continue"
              theme="primary"
              handleOnClick={() => startRecording({ noteType: '' })}
              icon={<span className="material-icons">mic</span>}
              disabled={initializing}
            />
            <Button
              text="Cancel"
              theme="transparent"
              handleOnClick={handleDrawerClose}
              customStyleClass={style.cancelButton}
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default IdleScreen;
